import { injectReducers } from '../../store/reducers'
import AppLayout from '../../components/Layouts/AppLayout'
import { AsyncComponent } from '../../components/Layouts/RouterLayout'
import * as ROUTES from '../../constants/routes'

const getContractContainer = store =>
  import(/* webpackChunkName: "product" */ './reducers')
    .then(module => injectReducers(store, module.default))
    .then(() => import(/* webpackChunkName: "product" */ './containers/ProductContainer'))
    .then(module => module.default)

export default (store) => ([
  {
    layout: AppLayout,
    exact: true,
    path: [
      ROUTES.PRODUCT_LIST_PATH,
      ROUTES.PRODUCT_DETAIL_PATH,
    ],
    component: AsyncComponent(() => getContractContainer(store))
  }
])
